module.exports = __webpack_public_path__ + "img/gcg_slogan.0c4ce2c5.png";